/** Error codes reported on `device.scan.failed`. */
export const SCAN_ERROR_CODE = {
  SCAN_ACTION_EXECUTION_FAILED: 'SCAN_ACTION_EXECUTION_FAILED',
  SCAN_ERROR: 'SCAN_ERROR',
  SCAN_NO_ACTION_MATCHED: 'SCAN_NO_ACTION_MATCHED',
} as const;
